export const LMS_SESSION_TYPES = [
  "Holiday Program",
  "PLE Revision Week",
  "Emergency Learning Period",
  "Special Instructional Program",
];

export const LMS_SESSION_STATUSES = [
  "Pending Approval",
  "Active",
  "Inactive",
  "Archived",
  "Completed",
];

export const LMS_CONTENT_TYPES = [
  { value: "lesson_note", label: "Lesson note / summary" },
  { value: "video", label: "Video / audio clip" },
  { value: "quiz", label: "Quiz / revision questions" },
  { value: "worksheet", label: "Digital worksheet" },
  { value: "reading_list", label: "Reading list" },
];

export const LMS_CONTENT_STATUSES = [
  "Draft",
  "Pending HOD Review",
  "Published",
  "Rejected",
  "Inactive",
];

export const LMS_ACTIVITY_TYPES = [
  { value: "login", label: "Login" },
  { value: "content_view", label: "Content viewed" },
  { value: "file_download", label: "File downloaded" },
  { value: "quiz_attempt", label: "Quiz attempted" },
  { value: "assignment_submit", label: "Assignment submitted" },
];

export const LMS_QUESTION_TYPES = [
  { value: "MCQ", label: "Multiple choice" },
  { value: "True/False", label: "True / False" },
  { value: "Short Answer", label: "Short answer" },
];

export const LMS_REPORT_STATUSES = [
  "Draft",
  "Deputy Reviewed",
  "Headteacher Approved",
];

export const LMS_LIVE_SESSION_STATUSES = [
  "Scheduled",
  "Live",
  "Completed",
  "Cancelled",
];

export const LMS_LIVE_SESSION_PLATFORMS = ["Zoom"];

export const LMS_VALID_FILE_EXTENSIONS =
  ".pdf,.doc,.docx,.txt,.rtf,.xls,.xlsx,.csv,.jpg,.jpeg,.png,.heic,.mp4,.mp3,.mov,.webm,.zip";

export const LMS_MAX_FILE_SIZE = 30 * 1024 * 1024;

export const LMS_PAGE_ROUTES = {
  dashboard: "/admin/lms/dashboard",
  sessions: "/admin/lms/sessions",
  content: "/admin/lms/content",
  uploadLog: "/admin/lms/content-upload-log",
  quizzes: "/admin/lms/quizzes",
  reports: "/admin/lms/weekly-reports",
  liveSessions: "/admin/lms/live-sessions",
};

export function statusColor(status) {
  switch (status) {
    case "Active":
    case "Published":
    case "Headteacher Approved":
    case "Present":
      return "green";
    case "Pending Approval":
    case "Pending HOD Review":
    case "Deputy Reviewed":
    case "Scheduled":
      return "gold";
    case "Rejected":
    case "Cancelled":
      return "red";
    case "Inactive":
    case "Archived":
      return "default";
    default:
      return "blue";
  }
}
